import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
    selector: 'beneficiary-clause',
    templateUrl: './beneficiary-clause.component.html',
    styleUrls: ['./beneficiary-clause.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class BeneficiaryClauseComponent implements OnInit {
  @Input() derrors = false;
  constructor() {}

  ngOnInit(): void {}
}
